import { Box } from '@mui/material'
import { getPxAsRem } from 'shared/utils'

interface WhiteLogoProps {
    'data-testid'?: string
}

const WhiteLogo: React.FC<WhiteLogoProps> = ({ 'data-testid': testId }) => {
    return (
        <Box
            height={'auto'}
            width={getPxAsRem(100)}
            component={'img'}
            src={'/cpi_white_logo.png'}
            alt="CPI logo"
            data-testid={testId} // Pass the data-testid prop to the Box component
        />
    )
}

export default WhiteLogo
